import { Select, SelectItem } from "@certn/cascadia-react";

type CheckTypeSelectorProps = {
  checkTypeOptions: {
    id: string;
    name: string;
  }[];
  selectedCheckId: string | null;
  onSelectionChange: (key: string | null) => void;
};

export function CheckTypeSelector({
  checkTypeOptions,
  selectedCheckId,
  onSelectionChange,
}: CheckTypeSelectorProps) {
  if (checkTypeOptions.length <= 1) {
    return null;
  }

  return (
    <Select
      testID="check-type-selector"
      selectedKey={selectedCheckId}
      onSelectionChange={(key) => onSelectionChange(key as string)}
    >
      {checkTypeOptions.map((option) => (
        <SelectItem key={option.id} id={option.id}>
          {option.name}
        </SelectItem>
      ))}
    </Select>
  );
}
